export default {
  // edit
  form: {
    company: '',
    name: '',
    email: '',
  },
};
